import { YesErrorTracking } from '@yes.technology/react-toolkit'

import ReactDOM from 'react-dom/client'

import apiAsync from 'infrastructure/shared/api/api-async'
import validateConfigUrls from 'infrastructure/shared/utils/validateConfigUrls'
import { tagManager } from 'shared/utils'
import store from 'state/store'

import reportWebVitals from './reportWebVitals'

import sanitizeSW from 'infrastructure/ServiceWorkerWrapper/utils/sanitizeServiceWorker'
import { ClientApp } from 'bootstrap/App'

validateConfigUrls(globalThis.apiUrls)
apiAsync.setConfig(globalThis.apiUrls)
apiAsync.setDispatch(store.dispatch)

YesErrorTracking({
  service: 'sentry',
  publicKey: globalThis.sentryDNS,
  traceTargets: globalThis.trackingUrls
})

tagManager.initialize(globalThis.tagManagerArgs)

const rootElement = document.getElementById('root') as HTMLElement

if (rootElement.children.length > 0) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(<ClientApp />)
} else {
  ReactDOM.hydrateRoot(rootElement, <ClientApp />)
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// registerServiceWorker()
sanitizeSW()
